import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Home from "../pages/Home";
import About from "../pages/About";
import CarListing from "../pages/CarListing";
import CarDetails from "../pages/CarDetails";
import Blog from "../pages/Blog";
import BlogDetails from "../pages/BlogDetails";
import NotFound from "../pages/NotFound";
import Contact from "../pages/Contact";
import Login from "../pages/Login";
import AdminDashboard from "../components/Dashboard/AdminDashboard/AdminDashboard";
import EquipmentMaintenance from "../components/Dashboard/EquipmentMaintenance/EquipmentMaintenance";
import Services from "../pages/Services";
import AllEquipment from "../components/UI/AllEquipment";
import ProjectDetail from "../components/UI/ProjectDetail";
import OurUlcTeam from "../components/UI/OurUlcTeam";
import DeveloperCrew from "../components/UI/DeveloperCrew";
import CompanyMaintenance from "../components/Dashboard/CompanyMaintenance/CompanyMaintenance";
import CategoryMaintenance from "../components/Dashboard/CategoryMaintenance/CategoryMaintenance";
import AllOrders from "../components/Dashboard/AllOrders/AllOrders";
import UserMaintenance from "../components/Dashboard/UserMaintenance/UserMaintenance";
import RenterOrderManagement from "../components/Dashboard/RentOrderManagement/RentOrderManagement";
import RenterDashboard from "../components/Dashboard/RenterDashboard/RenterDashboard";
import RenterPayment from "../components/Dashboard/RenterPayment/RenterPayment";
import PaymentVerifications from "../components/Dashboard/PaymentVerificatoin/PaymentVerificatoin";
import ChangePassword from "../components/Dashboard/ChangePassword/ChangePassword";
import CommissionLedgerReport from "../components/Dashboard/CommissionLedgerReport/CommissionLedgerReport";
import SupplierPayment from "../components/Dashboard/SupplierPayment/SupplierPayment";
import AdminDashboardd from "../components/Dashboard/AdminDashboard/AdminDashboardd";
import SupplierDashboardd from "../components/Dashboard/SupplierDashboard/SupplierDashboardd";
import SupplierDashboard from "../components/Dashboard/SupplierDashboard/SupplierDashboard";
import SupplierLedger from "../components/Dashboard/SupplierLedger/SupplierLedger";
import BlogMaintenance from "../components/Dashboard/BlogMaintenance/BlogMaintenance";
import BlogDisplay from "../components/UI/Blog";

const Routers = () => {
  return (
    // <Router basename="/">
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/equipment" element={<AllEquipment />} />
      <Route path="/projects" element={<ProjectDetail />} />
      <Route path="/ourteam" element={<OurUlcTeam />} />
      <Route path="/blogs" element={<BlogDisplay/>} />

      <Route path="/developercrew" element={<DeveloperCrew />} />

      <Route path="/cars" element={<CarListing />} />
      <Route path="/cars/:slug" element={<CarDetails />} />
      {/* <Route path="/blogs" element={<Blog />} /> */}
      <Route path="/blogs/:slug" element={<BlogDetails />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/login" element={<Login />} />
      <Route path="*" element={<NotFound />} />

      {/* Dashboard Nested Routes */}
      <Route path="/AdminDashboard" element={<AdminDashboard />}>
        <Route index element={<AdminDashboardd />} />
        <Route path="EquipmentMaintenance" element={<EquipmentMaintenance />} />
        <Route path="BlogMaintenance" element={<BlogMaintenance />} />

        <Route path="CompanyMaintenance" element={<CompanyMaintenance />} />
        <Route path="CategoryMaintenance" element={<CategoryMaintenance />} />
        <Route path="AllOrders" element={<AllOrders />} />
        <Route path="PaymentVerifications" element={<PaymentVerifications />} />
        <Route path="CommissionLedgerReport" element={<CommissionLedgerReport />} />
        <Route path="SupplierPayment" element={<SupplierPayment />} />

        <Route path="UserMaintenance" element={<UserMaintenance />} />
      </Route>


      <Route path="/RenterDashboard" element={<RenterDashboard />}>
        <Route index element={<div>Renter Dashboard Content</div>} />
        <Route path="RenterOrderManagement" element={<RenterOrderManagement />} />
        <Route path="RenterPayment" element={<RenterPayment />} />
        <Route path="ChangePassword" element={<ChangePassword />} />
      </Route>

      <Route path="/SupplierDashboard" element={<SupplierDashboard />}>
        <Route index element={<SupplierDashboardd />} />

         <Route path="EquipmentMaintenance" element={<EquipmentMaintenance />} />
        <Route path="CompanyMaintenance" element={<CompanyMaintenance />} />
        <Route path="CategoryMaintenance" element={<CategoryMaintenance />} />
        <Route path="SupplierLedger" element={<SupplierLedger />} />
        <Route path="ChangePassword" element={<ChangePassword />} />
      </Route>
    </Routes>
    // </Router>
  );
};

export default Routers;
